import type { AddProductsSourceKey } from '../../Tabs/ProductsTableBody/model/useAddProductsTransfer';
import { ShortageProductAdd, ShortageServiceAdd } from '../ShortageAddActions';
import { formatQty } from '../model/formatQty';
import type { ProposalShortageItem, ProposalShortageKind } from '../model/types';

interface ProductSourceOption {
    key: AddProductsSourceKey;
}

interface ShortageTableRowProps {
    kind: ProposalShortageKind;
    item: ProposalShortageItem;
    proposalName: string;
    showActions: boolean;
    canAdd: boolean;
    sources: ProductSourceOption[];
    teamName: string;
    openTransfer: (key: AddProductsSourceKey, productId?: number) => void;
}

const ShortageTableRow = ({
    kind,
    item,
    proposalName,
    showActions,
    canAdd,
    sources,
    teamName,
    openTransfer,
}: ShortageTableRowProps) => (
    <tr className={`proposal-shortage__tr proposal-shortage__tr--${item.status}`}>
        <td className="proposal-shortage__name-cell">
            <div className="text-truncate" title={item.name}>
                {item.name}
            </div>
            {(item.article || item.dimensionName) && (
                <div className="proposal-shortage__meta text-truncate">
                    {[item.article, item.dimensionName].filter(Boolean).join(' · ')}
                </div>
            )}
        </td>
        <td className="text-end text-nowrap">{formatQty(item.need)}</td>
        <td className="text-end text-nowrap">{formatQty(item.have)}</td>
        <td className="text-end text-nowrap proposal-shortage__deficit">
            −{formatQty(item.deficit)}
        </td>
        {showActions && (
            <td className="text-end proposal-shortage__actions-cell">
                {kind === 'products' ? (
                    <ShortageProductAdd
                        productId={Number(item.productId || 0)}
                        sources={sources}
                        teamName={teamName}
                        canAdd={canAdd}
                        openTransfer={openTransfer}
                    />
                ) : (
                    <ShortageServiceAdd item={item} proposalName={proposalName} />
                )}
            </td>
        )}
    </tr>
);

export default ShortageTableRow;
